<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <div class="mg-l-5 mg-r-5">
        <yo-button
          class="mg-r-10"
          iconClass="fa fa-plus"
          label="CRÉER"
          (onClick)="openDialogEdition(undefined)"
          tooltip="Créer un point de télédeclaration Ma Cantine">
        </yo-button>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="after" class="mg-r-16">

    <yo-button
      iconClass="fas fa-trash"
      buttonClass="cta-delete"
      (onClick)="deleteValues()"
      [disabled]="!canDelete()"
      tooltip="Supprimer les éléments sélectionnés">
    </yo-button>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [dataSource]="pointsTeledeclaration"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows">
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple"
  ></dxo-selection>
  <dxi-column dataField="id" caption="Actions"
              [width]="79"
              cssClass="text-align-center vertical-align-middle mg-r-0"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Libellé"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="site" caption="Site"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              cellTemplate="siteTemplate"
              [calculateCellValue]="calculateSiteValue">
  </dxi-column>
  <dxi-column dataField="siret" caption="SIRET"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="pointLivraisonClientList" alignment="left" caption="Point(s) de livraison(s)" cellTemplate="plcCellTemplate"
              width="400"
              [allowFiltering]="true"
              [filterOperations]="['contains']"
  ></dxi-column>
  <dxi-column dataField="actif" caption="Actif"
              [filterOperations]="['contains']"
              [allowFiltering]="true">
  </dxi-column>

  <div *dxTemplate="let cell of 'siteTemplate'">
    <yo-site [siteLibelle]="cell.row.data?.site?.libelle" [siteId]="cell.row.data?.site?.id"></yo-site>
  </div>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-cell-button
      (yoNavigation)="openDialogEdition(cell.row.data)"
      [yoTooltipShowDelay]="500"
      [yoSmall]="true"
      yoTextAlign="center"
      [yoIconClass]="pointTeledeclarationEgalimSvc.canModify(cell.row.data)? 'fa fa-edit' : 'fas fa-eye'"
      [yoTooltip]="pointTeledeclarationEgalimSvc.canModify(cell.row.data)? 'Modifier le point de télédeclaration Ma Cantine' : 'Voir le point de télédeclaration Ma Cantine'">
    </yo-cell-button>
  </div>

  <div *dxTemplate="let cell of 'plcCellTemplate'">
    <table>
      <tr>
        <td style="vertical-align: top;padding:4px;">
          <ng-container *ngFor="let plc of cell.row.data.pointLivraisonClientList">
            <div>
            <span class="genlabel">{{plc.libelle | uppercase}}</span>
            </div>
          </ng-container>
        </td>
      </tr>
    </table>
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} point(s) de télédeclaration">
  </dxo-pager>

</dx-data-grid>

<yo-point-teledeclaration-egalim-edition></yo-point-teledeclaration-egalim-edition>
